import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const DELETE_CASE_LINE = "DELETE_CASE_LINE";

export const service = async (eaCaseLineId) => {
  const options: object = {
    url: "/api/EaCaseApiController/DeleteCaseLine/" + eaCaseLineId,
    method: "POST",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_CASE_LINE, service, mock);
